export enum Declaration {
  ID_ANI = "ID_ANI",
}
